import { IAppState } from '@src/interfaces/IAppState';

export const dataFieldExpenseSeletor = (appState: IAppState) => {
  return appState.expenseState;
};

export const dataFieldIncomeSeletor = (appState: IAppState) => {
  return appState.incomeState;
};
